import React from "react";
import "../../styles/dashboard.css";


const DashboardView = () => {
  return (
    <div className="content-wrapper">
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1>Dashboard</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item"><a href="!#">Home</a></li>
                <li className="breadcrumb-item">Dashboard</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="dashboard-container">
                <div className="content">
                  hola
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );

};

export default DashboardView;